import { WidgetDescription } from 'controls/designer/features/widgets/types';
import { i18n } from 'core/localization';
import { DesignerStore } from 'controls/designer/designerStore';
import { DataSourceSelection } from 'areas/data-sources/types/dataSource';

import { TextWidget } from './textWidget';
import { TextWidgetEditor } from './components/text-widget-editor/textWidgetEditor';
import { TextWidgetConfig } from './types';

export function getWidgetDescription(): WidgetDescription<TextWidgetConfig> {
	return {
		form: TextWidgetEditor,
		defaultConfig: {
			type: 'text',
			title: i18n('Text'),
			text: '',
			dynamicEntries: [],
		},
		widget: TextWidget,
		fullTitle: i18n('Custom') + '/' + i18n('Text'),
		preProcessConfig: (config: TextWidgetConfig, store: DesignerStore) => {
			config = JSON.parse(JSON.stringify(config));

			// silent migration to the new format
			config.dynamicEntries?.forEach((entry) => {
				const selection = (entry as { dataSourceSelection?: DataSourceSelection }).dataSourceSelection;
				if (!selection) return;

				if (selection.dataSourceSelectorAccountId === undefined) {
					selection.dataSourceSelectorAccountId = selection.accountId;
				}
				if (store.config.accountId) {
					selection.accountId = store.config.accountId;
				}
			});

			return config;
		},
	};
}
